import { useEffect, useState } from 'react';
import { apiBaseUrl } from './config';

export function ReleasePage({ slug }: { slug: string }) {
 const [release,setRelease]=useState<any>(null);
 useEffect(()=>{fetch(`${apiBaseUrl}/api/releases/${slug}`).then(r=>r.json()).then(d=>setRelease(d.release)).catch(()=>{});},[slug]);
 if(!release) return <main className='release-page'><h1>Loading release...</h1></main>;
 return <main className='release-page'><h1>{release.title}</h1><p>{release.description}</p><pre>{release.lyrics || 'Lyrics coming soon.'}</pre></main>;
}
